import Ellipsis from 'ftellipsis';

import HTTPService from './services/HTTPService.es6';
import { ENTER_KEY } from './constants';
import Ga from './ga';
import Wa from './wa';

/**
 * Initialize featured realtors explanation
 * @param {Object} ga Google Analytics event parameters
 * @param {String} ga.category GA category
 * @param {String} ga.labelPrefix GA label prefix
 */
function initializeFeaturedRealtorsExplanation(ga) {
    const $featuredRealtorsExplanationBtn = $('#featured-realtors-explanation-btn');
    const $featuredRealtorsExplanationText = $('#featured-realtors-explanation-text');

    if ($featuredRealtorsExplanationBtn) {
        $featuredRealtorsExplanationBtn.on('click', () => {
            if ($featuredRealtorsExplanationText.attr('hidden') === 'hidden') {
                $featuredRealtorsExplanationText.removeAttr('hidden');
                return $featuredRealtorsExplanationBtn.attr('aria-expanded', true);
            }
            $featuredRealtorsExplanationText.attr('hidden', true);
            return $featuredRealtorsExplanationBtn.attr('aria-expanded', false);
        });

        $featuredRealtorsExplanationBtn.one('click', () => {
            Ga.send({
                hitType: 'event',
                eventCategory: ga.category,
                eventAction: 'seller_display_ads:show_information_about_advertisement',
                eventLabel: `${ga.labelPrefix}:seller_display_ads:realtors_card:information_cta`,
            });
        });
    }
}

/**
 * Load featured realtors with XHR
 * @param {{id: Number, geotype_label: String}} place Place to load realtors in
 * @param {String} pageName Name of page in which featured realtors will be displayed
 * @return {Promise}
 */
export function loadFeaturedRealtors(place, pageName) {
    return HTTPService.get(`/agences_sponsorisees/${place.geotype_label}/${place.id}/${pageName}`);
}

/**
 * Initialize featured realtors with XHR
 * @param {jQuery} container HTML Element to load featured realtors in
 * @param {Function} xhrCall HTTP Get request to retrieve featured realtors
 * @param {Object} ga Google Analytics event parameters
 * @param {String} ga.category GA category
 * @param {String} ga.labelPrefix GA label prefix
 */
export function initializeFeaturedRealtors(container, xhrCall, ga) {
    if (container && container.length > 0) {
        if (typeof xhrCall === 'function') {
            xhrCall().then(({ data: { realtors, sector_id: sectorId } }) => {
                if (sectorId) {
                    MA.Context.waData.sector_id = sectorId;
                }

                if (realtors === null) {
                    if (sectorId) {
                        const pageviewCategory = MA.Context.waData.pageview_category;
                        const waSource = `source=${pageviewCategory}`;

                        Wa.push(
                            'print',
                            `${pageviewCategory}:no_realtor_ad`,
                            `${waSource}${Wa.computeData(MA.Context.waData)}`,
                        );
                    }
                } else {
                    container.removeClass('hide');
                    container.html(realtors);

                    // We truncate reviews that are longer than 2 lines
                    const reviews = new Ellipsis(
                        document.querySelectorAll('[data-featured-realtor-review]'),
                    );

                    reviews.el.forEach(review => {
                        const ellipsis = new Ellipsis(review);
                        ellipsis.calc();
                        ellipsis.set();
                    });

                    const $featuredRealtorCard = $('[data-featured-realtor]');

                    $featuredRealtorCard.each(() =>
                        Ga.send({
                            hitType: 'event',
                            eventCategory: ga.category,
                            eventAction: 'seller_display_ads_realtor:card:landed',
                            eventLabel: `${ga.labelPrefix}:seller_display_ads_realtor`,
                            nonInteraction: true,
                        }),
                    );

                    $featuredRealtorCard.on('keypress', event => {
                        if (event.key === ENTER_KEY) {
                            const newTab = window.open(
                                $featuredRealtorCard.data('featured-realtor-url'),
                                '_blank',
                            );
                            newTab.focus();
                        }
                    });

                    initializeFeaturedRealtorsExplanation({
                        category: ga.category,
                        labelPrefix: ga.labelPrefix,
                    });

                    Wa.setDisplayTracking($('[data-featured-realtors]'), MA.Context.waData);
                }
            });
        }
    }
}
